import type { SVGProps } from 'react';

const SvgClock = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={8} cy={8} r={6} stroke="currentColor" strokeWidth={2} />
    <path d="M8 4v4l2 2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
  </svg>
);

export default SvgClock;
export { SvgClock };
